import React, { useEffect, useState } from "react";
import FiltersModel, { FieldConfig } from "../../components/ui/FiltersModel";
import FilterIcon from "../../components/icons/FitlerIcon";
import Pagination from "../../components/ui/Pagination";
import RenderTable from "../../components/ui/RenderTable";
import { Chip, pluralize } from "../../helpers/general";
import { useBookingQuery } from "../../hooks/bookings/useBookingQuery";
import { general } from "../../locales/general";
import BookingFilters from "./BookingFilters";
import BookingTable from "./BookingTable";
import { cardStyle } from "../Places/PlacesTable";

const PAGE_SIZE = 10;

const bookingsFilter: FieldConfig[] = [
  {
    field: "date",
    type: "date",
    label: "Date de réservation",
    operators: ["$eq", "$gt", "$lt", "$gte", "$lte", "$between"],
  },
];

export default function BookingsPage() {
  const [filtersVisible, setFiltersVisible] = useState(false);
  const [filters, setFilters] = useState<any[]>([]);
  const {
    bookings,
    fetchingBookings,
    totalItems,
    currentPage,
    setCurrentPage,
    isPreviousData,
    totalCount,
    setFilters: setBookingFilters,
  } = useBookingQuery();

  useEffect(() => {
    setBookingFilters(filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  const activeFilters = filters.length;

  return (
    <section>
      {/* Title + count + date filter */}
      <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
        <div className="d-flex align-items-center gap-2">
          <h5 className="fs-4 fw-bold mb-0">Réservations</h5>
          {totalCount !== undefined && (
            <Chip tone="warning">
              {totalCount} {pluralize("Réservation", totalCount)}
            </Chip>
          )}
        </div>

        <button
          type="button"
          onClick={() => setFiltersVisible(true)}
          className="btn btn-outline-danger rounded-pill d-flex align-items-center gap-2 px-3"
          style={{ height: 38 }}
        >
          <FilterIcon />
          Filtres{activeFilters > 0 && ` (${activeFilters})`}
        </button>
      </div>

      <FiltersModel
        open={filtersVisible}
        onClose={() => setFiltersVisible(false)}
        configs={bookingsFilter}
        callback={(f: any[]) => setFilters(f)}
      />

      {/* Existing filters (status, search, place...) */}
      <div style={{ ...cardStyle, padding: "12px 16px" }} className="mb-3">
        <BookingFilters disableFilters={false} />
      </div>

      {/* Table */}
      <div style={{ ...cardStyle, padding: 0, overflow: "hidden" }}>
        <RenderTable
          loading={fetchingBookings || isPreviousData}
          render={() =>
            bookings?.length > 0 ? (
              <BookingTable bookings={bookings} />
            ) : (
              <p className="text-center text-muted py-5 mb-0">
                {general.fr.noData}
              </p>
            )
          }
        />
      </div>

      <Pagination
        currentPage={currentPage}
        onPageChange={setCurrentPage}
        siblingCount={1}
        totalCount={totalItems}
        pageSize={PAGE_SIZE}
      />
    </section>
  );
}
